module.exports = "<div id=\"container-id\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/photo-viewer/photo-viewer.component.html
// module id = ../../../../../src/app/shared/photo-viewer/photo-viewer.component.html
// module chunks = main